var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page-table',{attrs:{"apiName":_vm.apiName,"nameRole":_vm.nameRoleEntity,"titleTable":_vm.titleTable,"paramsGetData":_vm.paramsGetData,"fieldLand":_vm.fieldLang,"apiDeleteName":_vm.apiDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }